function datadogMonitoring() {
  return typeof window !== "undefined" && window.CoolWorksDatadog
}

export function monitorAction(actionName, context = {}) {
  const monitoring = datadogMonitoring()
  if (!monitoring) return

  monitoring.addAction(actionName, context)
}

export function monitorError(message, context = {}, error = null) {
  const monitoring = datadogMonitoring()
  if (!monitoring) return

  monitoring.addError(message, context, error)
}

export function navigationType() {
  const nav = performance.getEntriesByType("navigation")
  if (nav && nav.length > 0 && nav[0].type) {
    return nav[0].type
  }

  return "unknown"
}

export function postFrontendDiagnostic(path, payload = {}) {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
  if (!csrfToken) return

  fetch(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
      "X-Requested-With": "XMLHttpRequest"
    },
    credentials: "same-origin",
    keepalive: true,
    body: JSON.stringify({ frontend_diagnostic: payload })
  }).catch(() => {
    // Best-effort diagnostics only; suppress client-side noise for this request.
  })
}
